// Anonymous device identity. Generated once per browser, stored in localStorage.
const KEY = "spotdrop_device_id";

function genId() {
  // Use crypto where available, fall back to a random hex string.
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return "dev-" + crypto.randomUUID().replace(/-/g, "");
  }
  return "dev-" + Array.from({ length: 32 }, () =>
    Math.floor(Math.random() * 16).toString(16)
  ).join("");
}

export function getDeviceId() {
  if (typeof window === "undefined") return null;
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = genId();
    localStorage.setItem(KEY, id);
  }
  return id;
}
